import axios from 'axios'

export const ApiBaseUrl = process.env.API_URL || 'https://hora-api.playtheron.tsno.de/api';

export const api = axios.create({
  baseURL: ApiBaseUrl,

});
